import auth from '@/http/requests/auth/login/index.js'
import organization from '@/http/requests/organization'
import Promise from 'lodash/_Promise'

export default {
  patchOrganization: (_, payload) => new Promise((resolve, reject) => {
    organization.patchOrganization(payload.id, payload.data)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  getOrganizationUsers: ({ commit }) => new Promise((resolve, reject) => {
    auth.organizationUsers()
      .then(response => {
        commit('SET_ORGANIZATION_USERS', response.data)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  getOrganizationUsersPaginated: (_, payload) => new Promise((resolve, reject) => {
    organization.getUsersPaginated(payload)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  getOrganizationUser: (_, payload) => new Promise((resolve, reject) => {
    organization.getUserById(payload)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  addOrganizationUser: (_, payload) => new Promise((resolve, reject) => {
    organization.addUser(payload)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  updateOrganizationUser: (_, payload) => new Promise((resolve, reject) => {
    organization.patchUser(payload.id, payload)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  fetchInvoices: (_, payload) => new Promise((resolve, reject) => {
    organization.getInvoices(payload.params)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
  downloadInvoice: (_, invoiceId) => new Promise((resolve, reject) => {
    organization.downloadInvoice(invoiceId)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  }),
}
